import { Component, ElementRef, Renderer2 } from "@angular/core";

@Component({
    selector: "sps-grid-row",
    template: `<ng-content></ng-content>`
})
export class SpsGridRowComponent {
    constructor(elementRef: ElementRef, renderer: Renderer2) {
        renderer.addClass(elementRef.nativeElement, "sps-row");
    }
}
